import React from "react";
// import Link from "next/link";
import { FormattedMessage } from "react-intl";
import { useEffect, useState } from "react";
import { getLanguage } from "localization/i8intl";

const Complaints = () => {
  const [language, setLanguage] = useState("");

  useEffect(() => {
    // console.log("Calling ads");
    // if (!isFirstTime) {
    setLanguage(getLanguage());
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };
      googletag.cmd.push(function () {
        googletag
          .defineOutOfPageSlot(
            "/1007232/Lallantop_Mobile_ROS_Mweb_Interstitial",
            googletag.enums.OutOfPageFormat.INTERSTITIAL
          )
          .addService(googletag.pubads());
        var SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;
        googletag.pubads().enableSingleRequest();
        googletag.enableServices();
      });
      googletag.pubads().refresh();
      // if (typeof apstag !== "undefined") {
      //   apstag.init({
      //     pubID: "7f0bbd82-5a13-48ec-9950-fcb028b1546c",
      //     adServer: "googletag",
      //     bidTimeout: 2e3,
      //   });
      //   // request the bids for the four googletag slots
      //   apstag.fetchBids(
      //     {
      //       slots: [
      //       ],
      //     },
      //     function (_) {
      //       // set apstag bids, then trigger the first request to GAM
      //       googletag.cmd.push(function () {
      //         apstag.setDisplayBids();
      //         googletag.pubads().refresh();
      //       });
      //     }
      //   );
      // }
    }, 500);
    // }
  }, []);
  return (
    <>
      <div className="factcheck-complaint">
        <ul className="breadcrumb aa">
          <li>
            <a href="/" passHref>
              <a>
                <i className="icon-cat-home"></i>
                <span>
                  <FormattedMessage id="home" defaultMessage="होम" />
                </span>
              </a>
            </a>
          </li>

          <li>
            <a href="/factcheck" passHref>
              <a>
                <span>
                  <FormattedMessage id="fact_check" defaultMessage="शो" />
                </span>
              </a>
            </a>
          </li>

          <li>
            <a href={``} passHref>
              <a>
                <span>{language === "hi" ? "शिकायत" : "Complaints"}</span>
              </a>
            </a>
          </li>
        </ul>
        <div className="complaints-paragraph">
          <h1>शिकायत</h1>
          <p>
            अगर आप हमारी पड़ताल के तरीके या नतीजे से असहमत हैं तो आप हमें{" "}
            <a href="mailto:padtaal@lallantop.com">padtaal@lallantop.com</a> पर
            ईमेल भेजकर अपनी सहमति या शिकायत दर्ज करा सकते हैं.
          </p>
          <p>
            हम आपकी असहमति का संज्ञान ज़रूर लेंगे. अगर आपको लगता है कि हम अपनी
            पड़ताल में आईएफसीएन (IFCN) के निर्देशों का पालन नहीं कर रहे हैं तो आप{" "}
            <a
              href="https://www.ifcncodeofprinciples.poynter.org/complaints-policy"
              target="_blank"
              rel="noreferrer"
            >
              इस लिंक पर क्लिक{" "}
            </a>{" "}
            करके सीधे आईएफसीएन को भी शिकायत भेज सकते हैं.
          </p>
        </div>
      </div>
    </>
  );
};

export async function getServerSideProps(ctx) {
  return {
    props: {},
  };
}
export default Complaints;
